export enum ServiceTaskChannel {
  CREATE = 'serviceTask::create',
  EDIT = 'serviceTask::patch',
  DELETE = 'serviceTask::delete',
}
